import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, vModelSelect as _vModelSelect, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = {
  key: 0,
  id: "Inforequest",
  class: "box-inforequest landing"
}
const _hoisted_2 = {
  key: 0,
  class: "app-width"
}
const _hoisted_3 = { class: "content" }
const _hoisted_4 = {
  key: 0,
  class: "main-title mrg"
}
const _hoisted_5 = { class: "form" }
const _hoisted_6 = ["disabled"]
const _hoisted_7 = { class: "item" }
const _hoisted_8 = {
  class: "label",
  for: "NameSurname"
}
const _hoisted_9 = { class: "control" }
const _hoisted_10 = { class: "item" }
const _hoisted_11 = {
  class: "label",
  for: "Phone"
}
const _hoisted_12 = { class: "control" }
const _hoisted_13 = ["placeholder"]
const _hoisted_14 = { class: "item" }
const _hoisted_15 = {
  class: "label",
  for: "Email"
}
const _hoisted_16 = { class: "control" }
const _hoisted_17 = ["placeholder"]
const _hoisted_18 = { class: "item" }
const _hoisted_19 = {
  class: "label",
  for: "Country"
}
const _hoisted_20 = { class: "control" }
const _hoisted_21 = ["value"]
const _hoisted_22 = {
  key: 0,
  class: "item"
}
const _hoisted_23 = {
  class: "label",
  for: "Zone"
}
const _hoisted_24 = { class: "control" }
const _hoisted_25 = ["value"]
const _hoisted_26 = {
  class: "item",
  "data-lable": "top"
}
const _hoisted_27 = {
  class: "label",
  for: ""
}
const _hoisted_28 = { class: "control" }
const _hoisted_29 = ["disabled"]
const _hoisted_30 = { class: "item" }
const _hoisted_31 = { class: "checkbox" }
const _hoisted_32 = ["innerHTML"]
const _hoisted_33 = ["disabled"]
const _hoisted_34 = { class: "item" }
const _hoisted_35 = ["data-sitekey"]
const _hoisted_36 = ["disabled"]
const _hoisted_37 = {
  key: 0,
  class: "validation-summary-errors"
}
const _hoisted_38 = { class: "item" }
const _hoisted_39 = { class: "cta" }
const _hoisted_40 = {
  key: 1,
  class: "button",
  "data-width": "300",
  "data-disabled": ""
}
const _hoisted_41 = {
  key: 1,
  class: "app-width success"
}
const _hoisted_42 = { class: "content" }
const _hoisted_43 = {
  class: "main-title",
  "data-mrgb": "30"
}
const _hoisted_44 = { class: "main-abstract" }

import { ref, computed, onBeforeMount } from "vue";
import Axios from "axios";
import Localizer from "@Scripts/Common/Localizer";
import FormHelper from "@Scripts/Common/FormHelper";
import GTagHelper from "@Scripts/Infrastructure/GTagHelper";


export default /*@__PURE__*/_defineComponent({
  __name: 'InfoRequest',
  props: {
    recaptchaSiteKey: {},
    titleForm: {},
    landingPageSlug: {}
  },
  setup(__props: any) {

const props = __props;

const localizer = Localizer;

const isLoading = ref<boolean>(true);
const isLoadingForm = ref<boolean>(false);
const isSuccess = ref<boolean>(false);
const formData = ref<any>({ country: null, zone: null, isPrivacyPolicy: false });
const countries = ref<any[]>([]);
const zones = ref<any[]>([]);
const validationErrors = ref<any[]>([]);
const routes = (window as any).App.routes;

onBeforeMount(async () => {
    await getData();
    setRecaptcha();
});

function setRecaptcha() {
    let recaptchaScript = document.createElement("script");
    recaptchaScript.setAttribute("src", "https://www.recaptcha.net/recaptcha/api.js");
    document.head.appendChild(recaptchaScript);
}

async function getData() {
    const response = (await Axios.post(routes.LandingPage_LandingPage_GetSubscribeData)).data;

    countries.value = response.countries;
    zones.value = response.zones;

    isLoading.value = false;
}

async function submitForm() {
    FormHelper.removeFocus();
    validationErrors.value = [];
    isLoadingForm.value = true;

    formData.value.landingPageSlug = props.landingPageSlug;

    try {
        await Axios.post(routes.LandingPage_LandingPage_Submit, formData.value, { headers: { "RecaptchaVerificationToken": (<any>window).grecaptcha.getResponse() } });

        isSuccess.value = true;

        GTagHelper.sendEvent("form_submit", "landing_info_request", props.titleForm);
    } catch (error) {
        if (error.response && error.response.status === 400) {
            validationErrors.value = FormHelper.getValidationErrors(error.response.data);
        }
    }

    (<any>window).grecaptcha.reset();

    isLoadingForm.value = false;
}

function isValidationError(controlName: string): boolean {
    return FormHelper.isControlValidationError(controlName, validationErrors.value);
}

return (_ctx: any,_cache: any) => {
  return (!isLoading.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (!isSuccess.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                (__props.titleForm)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(__props.titleForm), 1))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("fieldset", {
                    disabled: isLoadingForm.value,
                    class: "fieldset"
                  }, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("label", _hoisted_8, _toDisplayString(_unref(localizer).get("LandingPage.InfoRequest.NameSurname")), 1),
                      _createElementVNode("div", _hoisted_9, [
                        _withDirectives(_createElementVNode("input", {
                          type: "text",
                          id: "NameSurname",
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.nameSurname) = $event)),
                          class: _normalizeClass([{ 'input-validation-error': isValidationError('NameSurname') }, 'textbox'])
                        }, null, 2), [
                          [
                            _vModelText,
                            formData.value.nameSurname,
                            void 0,
                            { lazy: true }
                          ]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("label", _hoisted_11, _toDisplayString(_unref(localizer).get("LandingPage.InfoRequest.Phone")), 1),
                      _createElementVNode("div", _hoisted_12, [
                        _withDirectives(_createElementVNode("input", {
                          type: "tel",
                          id: "Phone",
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.phone) = $event)),
                          placeholder: _unref(localizer).get('LandingPage.InfoRequest.PhonePlaceholder'),
                          class: _normalizeClass([{ 'input-validation-error': isValidationError('Phone') }, 'textbox'])
                        }, null, 10, _hoisted_13), [
                          [
                            _vModelText,
                            formData.value.phone,
                            void 0,
                            { lazy: true }
                          ]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _createElementVNode("label", _hoisted_15, _toDisplayString(_unref(localizer).get("LandingPage.InfoRequest.Email")), 1),
                      _createElementVNode("div", _hoisted_16, [
                        _withDirectives(_createElementVNode("input", {
                          type: "email",
                          id: "Email",
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.email) = $event)),
                          placeholder: _unref(localizer).get('LandingPage.InfoRequest.EmailPlaceholder'),
                          class: _normalizeClass([{ 'input-validation-error': isValidationError('Email') }, 'textbox'])
                        }, null, 10, _hoisted_17), [
                          [
                            _vModelText,
                            formData.value.email,
                            void 0,
                            { lazy: true }
                          ]
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _createElementVNode("label", _hoisted_19, _toDisplayString(_unref(localizer).get("LandingPage.InfoRequest.Country")), 1),
                      _createElementVNode("div", _hoisted_20, [
                        _withDirectives(_createElementVNode("select", {
                          id: "Country",
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.country) = $event)),
                          class: _normalizeClass([{ 'input-validation-error': isValidationError('Country') }, 'dropdown'])
                        }, [
                          _cache[8] || (_cache[8] = _createElementVNode("option", { value: null }, "...", -1)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(countries.value, (country, index) => {
                            return (_openBlock(), _createElementBlock("option", {
                              value: country.value,
                              key: index
                            }, _toDisplayString(country.title), 9, _hoisted_21))
                          }), 128))
                        ], 2), [
                          [
                            _vModelSelect,
                            formData.value.country,
                            void 0,
                            { lazy: true }
                          ]
                        ])
                      ])
                    ]),
                    (formData.value.country === 'IT')
                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                          _createElementVNode("label", _hoisted_23, _toDisplayString(_unref(localizer).get("LandingPage.InfoRequest.Zones")), 1),
                          _createElementVNode("div", _hoisted_24, [
                            _withDirectives(_createElementVNode("select", {
                              id: "Zone",
                              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formData.value.zone) = $event)),
                              class: _normalizeClass([{ 'input-validation-error': isValidationError('Zone') }, 'dropdown'])
                            }, [
                              _cache[9] || (_cache[9] = _createElementVNode("option", { value: null }, "...", -1)),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(zones.value, (zone, index) => {
                                return (_openBlock(), _createElementBlock("option", {
                                  value: zone.value,
                                  key: index
                                }, _toDisplayString(zone.title), 9, _hoisted_25))
                              }), 128))
                            ], 2), [
                              [
                                _vModelSelect,
                                formData.value.zone,
                                void 0,
                                { lazy: true }
                              ]
                            ])
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("label", _hoisted_27, _toDisplayString(_unref(localizer).get("LandingPage.InfoRequest.Message")), 1),
                      _createElementVNode("div", _hoisted_28, [
                        _withDirectives(_createElementVNode("textarea", {
                          cols: "15",
                          type: "text",
                          id: "Message",
                          maxlength: "500",
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.value.message) = $event)),
                          rows: "3",
                          class: _normalizeClass([{ 'input-validation-error': isValidationError('Message') }, 'textarea'])
                        }, null, 2), [
                          [
                            _vModelText,
                            formData.value.message,
                            void 0,
                            { lazy: true }
                          ]
                        ])
                      ])
                    ])
                  ], 8, _hoisted_6),
                  _createElementVNode("fieldset", {
                    disabled: isLoadingForm.value,
                    class: "fieldset"
                  }, [
                    _createElementVNode("div", _hoisted_30, [
                      _createElementVNode("div", _hoisted_31, [
                        _withDirectives(_createElementVNode("input", {
                          type: "checkbox",
                          id: "isPrivacyPolicy",
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formData.value.isPrivacyPolicy) = $event))
                        }, null, 512), [
                          [_vModelCheckbox, formData.value.isPrivacyPolicy]
                        ]),
                        _createElementVNode("label", {
                          for: "isPrivacyPolicy",
                          innerHTML: _unref(localizer).get('LandingPage.InfoRequest.PrivacyPolicy', _unref(routes).Terms_PrivacyPolicy)
                        }, null, 8, _hoisted_32)
                      ])
                    ])
                  ], 8, _hoisted_29),
                  _createElementVNode("fieldset", {
                    disabled: isLoadingForm.value,
                    class: "fieldset"
                  }, [
                    _createElementVNode("div", _hoisted_34, [
                      _createElementVNode("div", {
                        class: "g-recaptcha",
                        "data-sitekey": __props.recaptchaSiteKey
                      }, null, 8, _hoisted_35)
                    ])
                  ], 8, _hoisted_33),
                  _createElementVNode("fieldset", {
                    disabled: isLoadingForm.value,
                    class: "fieldset"
                  }, [
                    (validationErrors.value.length !== 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                          _createElementVNode("ul", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(validationErrors.value, (validationError, index) => {
                              return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(validationError.message), 1))
                            }), 128))
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_38, [
                      _createElementVNode("div", _hoisted_39, [
                        (!isLoading.value)
                          ? (_openBlock(), _createElementBlock("button", {
                              key: 0,
                              class: "button",
                              "data-width": "300",
                              onClick: _cache[7] || (_cache[7] = ($event: any) => (submitForm()))
                            }, _toDisplayString(_unref(localizer).get("LandingPage.InfoRequest.SendRequest")), 1))
                          : (_openBlock(), _createElementBlock("div", _hoisted_40, [...(_cache[10] || (_cache[10] = [
                              _createElementVNode("div", {
                                class: "loader-box",
                                "data-type": "button"
                              }, [
                                _createElementVNode("div", { class: "loader" })
                              ], -1)
                            ]))]))
                      ])
                    ])
                  ], 8, _hoisted_36)
                ])
              ]),
              _cache[11] || (_cache[11] = _createElementVNode("img", {
                src: "/images/box-inforequest.png",
                width: "462",
                height: "721",
                alt: "Mecmedix",
                class: "image"
              }, null, -1))
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_41, [
              _createElementVNode("div", _hoisted_42, [
                _createElementVNode("div", _hoisted_43, _toDisplayString(_unref(localizer).get("LandingPage.InfoRequest.FormSuccessTitle")), 1),
                _createElementVNode("div", _hoisted_44, _toDisplayString(_unref(localizer).get("LandingPage.InfoRequest.FormSuccessDescription")), 1)
              ]),
              _cache[12] || (_cache[12] = _createElementVNode("img", {
                src: "/images/box-inforequest.png",
                width: "462",
                height: "721",
                alt: "Mecmedix",
                class: "image"
              }, null, -1))
            ]))
      ]))
    : _createCommentVNode("", true)
}
}

})